module.exports = __webpack_public_path__ + "img/qrcode.006c3e29.jpg";